import React, { ChangeEvent } from 'react';
import styles from './SearchBar.module.css';
import { exploreIcon } from '../../assets/icons';

/**
 * Interface for the SearchBar component props
 */
interface SearchBarProps {
  value: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  onClear?: () => void;
  activeSearchQuery?: string;
  className?: string;
}

/**
 * Shared search bar component for the explore view
 * Used by both mobile and desktop views
 */
const SearchBar: React.FC<SearchBarProps> = ({ 
  value, 
  onChange, 
  onClear, 
  activeSearchQuery, 
  className 
}) => {
  const hasActiveSearch = activeSearchQuery && activeSearchQuery.trim() !== '';
  
  return (
    <div className={`${styles.searchBar} ${className || ''}`}>
      <div className={styles.searchContainer}>
        {exploreIcon && (
          <img src={exploreIcon} alt="Search" className={styles.searchIcon} />
        )}
        <input 
          type="text" 
          placeholder="Search" 
          className={styles.searchInput}
          value={value}
          onChange={onChange}
          aria-label="Search characters"
          autoComplete="off"
          autoCorrect="off"
          autoCapitalize="off"
          spellCheck="false"
        />
        {value && (
          <button 
            type="button" 
            className={styles.clearButton}
            onClick={() => {
              if (onClear) onClear();
            }}
            aria-label="Clear search"
          >
            ×
          </button>
        )}
      </div>
      {hasActiveSearch && (
        <div className={styles.activeSearchIndicator}>
          <span>Showing results for: "{activeSearchQuery}"</span>
          <button 
            type="button" 
            className={styles.clearSearchButton}
            onClick={() => {
              if (onClear) onClear();
            }}
          >
            Clear
          </button>
        </div>
      )}
    </div>
  );
};

export default SearchBar; 